<template>
<v-container>
<v-banner single-line>
    <v-icon
      slot="icon"
      color="primary"
      size="36"
    >
      mdi-domain
    </v-icon>
    Car Tag Builder
    <template v-slot:actions>
      
<v-btn
  elevation="2"
  v-on:click="goToConciergePad"
  color="primary"
  outlined
>Logout
      <v-icon
        right
        dark
      >
        mdi-exit-to-app
      </v-icon>
      </v-btn>
    </template>
  </v-banner>
      <v-row>
           <v-progress-linear
           v-if="doProgress"
      indeterminate
      color="yellow darken-2"
    ></v-progress-linear>

<v-col cols="12" md="6">

 <h4>Students</h4>

  <v-chip
      v-if="arrayIsEmpty"
      class="ma-2"
   
    >
      <v-icon
      color="primary"
      size="26"
    >
      mdi-arrow-down
    </v-icon>
      Drag and Drop Zone
    </v-chip>

    <v-chip
      v-if="arrayIsEmpty"
      class="ma-2"
   
    >
      <v-icon
      color="primary"
      size="26"
    >
      mdi-arrow-left
    </v-icon>
    <v-icon
      color="primary"
      size="26"
    >
      mdi-arrow-right
    </v-icon>
      Move items back and forth
    </v-chip>
      <draggable class="tags" :list="missingStudents" group="people" @change="studentChanged">
        <div
          class="list-group-item"
          v-for="(element) in missingStudents"
          :key="element.studentId"
        >
              <v-icon
      color="primary"
      size="26"
    >
      mdi-drag-horizontal
    </v-icon> {{ element.firstName }}  {{ element.lastName }} / {{element.studentId}}  - Grade: {{element.grade}} <br>

        </div>
      </draggable>
 
</v-col>

<v-col cols="12"  md="6">

  <h4>Car Tags</h4>



     <v-text-field
            v-model="carTagAdd"
            append-outer-icon="mdi-plus-circle"
            clear-icon="mdi-close-circle"
            label="Add Car Tag to list"
            type="number"
            @click:append-outer="sendMessage"
          ></v-text-field>

       <v-text-field
            placeholder="Search Car Tag"
            v-model="searchValue"
             prepend-icon="mdi-magnify"
            @keyup="filterSearch"
          ></v-text-field> 

           <v-text-field
            placeholder="Search Name"
            v-model="nameValue"
             prepend-icon="mdi-account-school"
            @keyup="nameSearch"
          ></v-text-field> 

        <div 
          slot="header"
          class="list-group-item"
          v-for="(element,index) in carTags"
          :key="element.hangerId"
          :index="index"
        >
        <v-card class="mx-auto" elevation="2">
            <v-icon
      color="primary"
      size="26"
    >
      mdi-tag-text-outline
    </v-icon>
    
     TAG ID: {{ element.hangerId }}

          <draggable class="list-group" :list="element.students" group="people" @change="carTagChanged"  v-on:change="selectionChanged(element.hangerId,index) " >

                <div class="tags" v-for="(student) in element.students" :key="student.name">

                    <v-icon
      color="primary"
      size="26"
    >
      mdi-drag-horizontal
    </v-icon> {{ student.firstName }}  {{ student.lastName }} /{{student.studentId}} - Grade: {{student.grade}}


                </div>


          </draggable>

           
</v-card>
        
        </div>

</v-col>

   
  </v-row>

</v-container>
</template>


<script>

  import axios from 'axios';
  import draggable from 'vuedraggable';

  export default {
       components: {
        draggable,
    },
    data: () => ({
      passwordAlert: false,
        missingStudents: [],
       carTags: [],
     stories: [
        {
          title: 'Strategy 101',
          description: 'Create a draft of business plan',
          time: '3 days',
          done: false
        },
        {
          title: 'Strategy 102',
          description: 'Finalize the plan',
          time: '4 days',
          done: false
        },
        {
          title: 'Tech diagram',
          description: 'Draw the tech data',
          time: '4 days',
          done: false
        },
        {
          title: 'Place Holder',
          description: 'Data Science Team',
          time: '5 days',
          done: false
        }
      ],

      dropGroups: [
        {
          name: 'Business Team',
          children: []
        },
        {
          name: 'Tech Dept',
          children: []
        },
        {
          name: 'Marketing Dept',
          children: []
        }
      ],
      arrayIsEmpty: true,
      searchValue: '',
      message: '',
      alert: false,
      pId: '',
      username: '',
      carTagAdd: '',
      password: '',
      reTypePassword: '',
      valid: true,
      doProgress: false,
      progressValue: 0,
      validCode: false,
      invalidCode: false,
      index: '',
      items: [],
      name: '',
      nameRules: [
        v => !!v || 'Field is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    }),

  


    mounted: function() {
      
    this.$watch('carTags', function (newVal) {
            console.log("New Value")
            console.log(newVal)
            console.log("Index")
            console.log(this.index);
    }, {deep:true})



      this.companyName = this.$route.query.uuid;

      this.getCarTags(this.companyName);
      this.getMissingStudents(this.companyName);

   
  },

    methods: {


    eventify:    function  (arr) {
        console.log("watch called")
  let eventify = function(arr) {
    arr.isEventified = true;
    // overwrite 'push' method
    let pushMethod = arr.push;
    arr.push = function(e) {
      pushMethod.call(arr, e);
      // the user added something into the array using 'push'
      // so at this point I can trigger my own code
      console.log(arr)
      console.log(e)
    };

    // overwrite 'splice' method
    let spliceMethod = arr.splice;
    arr.splice = function() {
      let args = [], len = arguments.length;
      while (len--) args[len] = arguments[len];
      spliceMethod.apply(arr, args);

      let idx = args[0];
      let nbDel = args[1];
      let elemsLen = args.length - 2;

      if (elemsLen === 0) {
        // we reach this part of the code when the user removed some elements from the array
        nbDel += idx;
        while(idx < nbDel) {
          // element at position 'idx' has been deleted
          idx++;
        }
      }
      else if (elemsLen > 0) {
        // we reach this part of the code when the user used this.$set(list, i, "new value")
        for (let i=2; i<elemsLen+2; i++) {
          // element at position 'idx' has been changed
          idx++;
        }
      }
    };
  };

  // make sure we don't "eventify" this array
  if (!arr.isEventified) eventify(arr);
},



    add: function() {
      this.list.push({ name: "Juan" });
    },
    replace: function() {
      this.list = [{ name: "Edgard" }];
    },
    clone: function(el) {
      return {
        name: el.name + " cloned"
      };
    },
    log: function() {
      //window.console.log(evt);
      console.log("log");
    },
    goToConciergePad: function() {

       console.log('Logging out')

       this.$router.push('Builder');

       //window.location.href = "https://www.conciergepadedu.com/login";


   },
     selectionChanged: function(item,index) {

         //console.log("selectionChanged")
         
         //console.log(item);

         //console.log(index);

         console.log("This is array for post: " + this.carTags[index]);

         this.postCarTag(this.carTags[index],this.companyName);



    },
    sendMessage: function() {
       
        if (this.carTagAdd) {

        this.$confirm("Are you sure you want to add car tag?").then(() => {

             console.log("send message");

             this.createCarTag(this.carTagAdd,this.companyName);

        });

        }
       

    },
     carTagChanged: function(evt) {
      //console.log(this.carTags)
     
      //console.log(this.carTags[evt.added.newIndex]);
      //console.log(evt.added.newIndex);
      console.log(evt.added.element.firstName)
      //console.log(evt.added.element.lastName)
      //console.log(evt.added.element.studentId)
      //console.log(evt.added.element.grade)
    },
     studentChanged: function(evt) {

      console.log(evt.added.element.studentId)

      //this.removeTag(evt.added.element.studentId,this.companyName);

    },
    addCarTag(hangerId,studentId) {

        //console.log(hangerId);
        console.log(studentId);
    },
    getMatchingResults() {

        console.log(this.searchValue);

         this.carTags = this.carTags.filter(d => this.searchValue.split(' ').every(v => d.toLowerCase().includes(v.toLowerCase())))

    },
    filterSearch() {

          console.log(this.searchValue);


           if (this.searchValue) {
                var arrayFiltered = this.carTags.filter( (car) => {
                    return car.hangerId.toLowerCase().indexOf(this.searchValue.toLowerCase()) != -1
                });
                this.carTags = arrayFiltered;
            } else {

                 this.getCarTags(this.companyName);
            }

        

    },

    nameSearch() {

      if (this.nameValue == '') 
      {
          this.getCarTags(this.companyName);

          console.log("return all the array because it is blank")
          return
      } else {


           const parents = this.carTags.filter((car) => {
                return car.hangerId.toLowerCase().includes(this.nameValue.toLowerCase());
                });
            const childs = this.carTags.filter((car) => {
                return car.students.filter((it) => {
                    return it.lastName.toLowerCase().includes(this.nameValue.toLowerCase())
                     }).length;
                });

                console.log(childs)

                parents.concat(childs);

                console.log("Array count: " + parents.concat(childs).length)

            if (parents.concat(childs).length > 0) {

               this.carTags = parents.concat(childs);
            }


      }
           

   

      return this.carTags;
    },

    nameSearch2() {

          console.log(this.nameValue);





           if (this.nameValue) {
         



                const term = this.nameValue.toLowerCase();
                if(!term) return this.carTags;
                // only questions or answers which contain the term will be returned

                console.log("fire search")
                return this.carTags.filter(qa => qa.students.lastName.toLowerCase().indexOf(term) >= 0 
                        || qa.students.firstName.toLowerCase().indexOf(term) >= 0);


            } else {

                 this.getCarTags(this.companyName);
            }

        

    },
    getCarTags:function(companyName) {

        this.doProgress = true;
        this.progressValue = 33;
        

      axios.get('https://api.conciergepadedu.com/api/Hangers/GetCarTags/' +  companyName).then(response => {

      if (response.data.error) {

       console.log(response.data.error)
       this.progressValue = 100;
       this.doProgress = false;


      } else {

        this.doProgress = true;
        this.progressValue = 66;

        console.log(response.data);

        //successful
        this.carTags = response.data;
        this.progressValue = 100;
        this.doProgress = false;

        }

        }).catch(error => {

            console.log(error.response)
            this.progressValue = 100;
            this.doProgress = false;

         
        });

    },

    postCarTag(carTagArray,companyName) {

    axios.post('https://api.conciergepadedu.com/api/Hangers/PostCarTag',carTagArray,companyName).then(response => {


      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error);

      } else {

      console.log('success', response.data);
      console.log('Here is the companyName: ' + companyName)


        //this.$alert("No Household ID detected","Add","error");
        

   

   
      
      
      } 

  

        }).catch(error => {

            console.log(error.response);




        });

 

  },
  createCarTag(carTag,companyName) {

    axios.post('https://api.conciergepadedu.com/api/Hangers/CreateTag',{
        hangerId:carTag,
        companyName:companyName
    }).then(response => {


      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error);

      } else {

      console.log('success', response.data);
      console.log('Here is the companyName: ' + companyName)

      this.getCarTags(this.companyName);
      this.getMissingStudents(this.companyName);


        //this.$alert("No Household ID detected","Add","error");
        

   

   
      
      
      } 

  

        }).catch(error => {

            console.log(error.response);




        });

 

  },

  removeTag(studentId,companyName) {

    axios.post('https://api.conciergepadedu.com/api/Hangers/RemoveTag',{
        studentId:studentId,
        companyName:companyName
    }).then(response => {


      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error);

      } else {

      console.log('student success', response.data);
      console.log('Here is the companyName: ' + companyName)

      this.getMissingStudents(this.companyName);


        //this.$alert("No Household ID detected","Add","error");
        

   

   
      
      
      } 

  

        }).catch(error => {

            console.log(error.response);


        });

 

  },

    getMissingStudents:function(companyName) {

      axios.get('https://api.conciergepadedu.com/api/Hangers/GetMissingStudents/' +  companyName).then(response => {

      if (response.data.error) {

       console.log(response.data.error)

      } else {

        console.log(response.data);

        //successful
        this.missingStudents = response.data;


        }

        }).catch(error => {

            console.log(error.response)

            this.validCode = false;
            this.invalidCode = true;

        });

    },


      getUserId:function(inId) {

      axios.get('https://api.conciergepadedu.com/api/Users/GetUserId/' +  inId).then(response => {

      if (response.data.error) {

        this.validCode = false;
        this.invalidCode = true;

      } else {

        console.log(response.data);

        //successful
        this.validCode = true;
        this.invalidCode = false;

        this.items = response.data;

        this.username = this.items.username;


        }

        }).catch(error => {

            console.log(error.response)

            this.validCode = false;
            this.invalidCode = true;

        });

    },
    updateUser() {

      if (this.password.length == 0 || this.reTypePassword == 0) {

        this.passwordAlert = true;
        this.message = "Password can't be blank";

      }
      else if (this.password != this.reTypePassword) {

        this.passwordAlert = true;
        this.message = "Passwords have to match";
      }
       else if (this.password.length < 7) {

        this.passwordAlert = true;
        this.message = "Passwords have to be at least 6 digits";
      }

       else if (this.invalidCode == true) {

         console.log("Invalid Email");

      }

      else {

        this.passwordAlert = false;
        this.message = "";

      axios.put('https://api.conciergepadedu.com/api/Users/PutUser/' + String(this.pId),{ 
         ID: String(this.pId),
         USERNAME: this.items.logiN_UUID,
         PASSWORD:  this.password,
         COMPANY_NAME: this.items.companY_NAME,
         UUID: this.items.uuid,
         DATE_CREATED: this.items.datE_CREATED,
         MOBILE_PHONE:  this.items.mobilE_PHONE,
         FIRST_NAME: this.items.firsT_NAME,
         LAST_NAME: this.items.lasT_NAME,
         EMAIL: this.username,
         DOB: this.items.dob,
         HANGER_ID: this.items.hangeR_ID
      }).then(response => {


      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error)

      } else {


          this.alert = true;

          this.password = '';
          this.reTypePassword = '';
          this.validCode = false;
          this.invalidCode = false;


        } 

  

        }).catch(error => {

            console.log(error.response)




        });

      }

    },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>

<style>


.tags {
      border: solid 1px gray;
      margin-top: 5px;
      margin-bottom: 5px;
      margin-left: 10px;
      margin-right: 10px;
    }

</style>